import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { RiskScanResult, RiskWindow } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

// Runs the rules now instead of waiting for the 5-minute background scan.
const useRiskScan = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const scan = (onDone?: () => void, window?: RiskWindow) => {
    request(
      { url: 'api/v1/admin/risk/scan', method: 'post', params: window ? { window } : undefined },
      ({ data }: SuccessHttpResponse<RiskScanResult>) => {
        const changes = [
          data.created && `${data.created} new`,
          data.reopened && `${data.reopened} reopened`,
          data.cleared && `${data.cleared} cleared`,
        ].filter(Boolean);
        toast.success(
          `Scan done in ${data.duration_ms}ms — ${changes.length ? changes.join(', ') : 'no changes'}`
        );
        onDone?.();
      },
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'Risk scan failed')
    );
  };

  return { loading, scan };
};

export default useRiskScan;
